import React, { useCallback } from 'react';
import { reportPopClick } from '@/utils/report';
import { MODAL_CONTENT } from '../../config';
import styles from './index.less';

const RecallModal = ({ pageName, visible, type, onOk, onClose }) => {
  const modalContent = MODAL_CONTENT[type] || {};

  const handleOk = useCallback(() => {
    // Handle different actions based on type
    reportPopClick({
      page_name: pageName,
      pop_name: MODAL_CONTENT[type].popName,
      button_name: 'ok_btn',
    });
    onOk();
  }, [onOk, pageName, type]);

  const handleCancel = useCallback(() => {
    reportPopClick({
      page_name: pageName,
      pop_name: MODAL_CONTENT[type].popName,
      button_name: 'cancel_btn',
    });
    onClose();
  }, [onClose, pageName, type]);

  if (!type || !modalContent || !visible) return null;

  return (
    <div className={`${styles.recallModal} ${visible ? styles.show : ''}`} onClick={handleCancel}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <img className={styles.icon} src={modalContent.icon} alt="状态图标" />
        <h3 className={`${styles.title} ${type === 'success' ? styles.success : ''}`}>
          {modalContent.title}
        </h3>
        <div className={styles.text}>
          {modalContent.content.split('\n').map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
        <div className={styles.btnGroup}>
          {modalContent.cancelText && (
            <button className={styles.cancelBtn} onClick={handleCancel}>
              {modalContent.cancelText}
            </button>
          )}
          <button
            className={`${styles.okBtn} ${type === 'success' ? styles.success : ''}`}
            onClick={handleOk}
          >
            {modalContent.okText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecallModal;
